import { BinderConfigurator, ComponentTagMappings, SamePropertyNamesBinder, ViewGenerator } from "binder";
import momentNamepsace from "moment";
import { MainWindowView } from "./common/mainWindow/mainWindow-view";
import { MainWindowViewModel } from "./common/mainWindow/mainWindow-viewModel";
import { Converters } from "./converters";
import { TranslatorConverter } from "./TranslatorConverter";
import { MediaSelector } from "./uicomponents/components/mediaSelector";
declare var moment;
declare var currentSystemLanguage;
import { Stimulsoft } from "types/stimulsoft.reports";
import i18next from 'i18next';
import { translate } from "./common/utilities";
declare var persianDate:any;

export class WindowData{
    public static BroadCastChannels:BroadcastChannel[] = [];
}

window.onbeforeunload = function(){
    WindowData.BroadCastChannels.forEach(x=>{
        x.postMessage({
            type:'informClose'
        });
        x.close();
    });
}
window.onload =async function(){
    persianDate.toLeapYearMode('astronomical');
    if(screen.width > 800) {
        var vp = document.querySelector('meta[name="viewport"]');
        vp.setAttribute('content','width=device-width, initial-scale=0.8');
    }
    let result = await fetch('/res/translation/translations.json',{
        method:'GET',
    });
    let resources = await result.json();
    i18next.init({
        lng: currentSystemLanguage,
        debug: true,
        parseMissingKeyHandler : k=>null,
        initImmediate: false,
        resources : resources        
    });
    require('uicomponents');
    moment = momentNamepsace;
    new BinderConfigurator().pushConverterRepository(new Converters());
    new BinderConfigurator().pushConverterRepository(new TranslatorConverter());
    let url =new URL(document.location.toString());
    let searchParams = [...url.searchParams];
    let formId = undefined;
    if(searchParams.at(0) && searchParams.at(0)[0]=='formid' && searchParams.at(0)[1]){
        formId = searchParams.at(0)[1];
    }
    let viewModel = new MainWindowViewModel(null,formId);
    const mainPageDiv = document.getElementById('mainPageDiv');
    function render(media?){
        
        let view = viewModel.GetDefaultView();
        view.dataContext = viewModel;
        SamePropertyNamesBinder.bindSourceAndDestination(viewModel,view);
        let html = ViewGenerator.GetHtml(view);
        mainPageDiv.replaceChildren(html)
        view.onRenderCompleted();
    }
    let mediaSelector = new MediaSelector();
    mediaSelector.addListenner(x=>render(x));
    render();

    // Stimulsoft.Report.Dictionary.StiFunctions.addFunction("Apadana","Apadana","ToPersianDate","","StimulFunctions",Stimulsoft.System.Long,"",[Stimulsoft.System.DateTime],["d"],null,function(d){return "aaa";});

}
document.addEventListener('keydown', function (event) {
    function findParent(element:HTMLElement) : HTMLElement{
        let form = $(element).parents('#V-652E83D2-1D8B-4FE8-ABFB-AB99EA82ECF9')
        if(form.length==0)
            form = $(document.body);
        return form[0];
    }

    function findFocusables(element:HTMLElement):JQuery<HTMLElement>{
        let allElements = $(element).find(
            'a:not([disabled]), button:not([disabled]), input:not([disabled]),select:not([disabled]),textarea:not([disabled]), [tabindex]:not([disabled]):not([tabindex="-1"])'
        ).filter(':visible:tabbable'); 
        let inerts = $(element).find('[inert]')
            .find('a:not([disabled]), button:not([disabled]), input:not([disabled]),select:not([disabled]),textarea:not([disabled]), [tabindex]:not([disabled]):not([tabindex="-1"])')
            .filter(':visible:tabbable');

        let result = allElements.not(inerts);
        return result;
    }
    // function findFocusables2(element:HTMLElement){
    //     function shallTraverseChildren(element:HTMLElement):boolean{
    //         if(element.hasAttribute("inert"))
    //             return false;
    //         return true;
    //     }
    //     function isFocusable(element:HTMLElement):boolean{
    //         switch(element.tagName){
    //             case "INPUT":
    //             case "A":
    //             case "SELECT":
    //             case "BUTTON":
    //             case "TEXTAREA":
    //                 break;
    //             default:
    //                 return false;
    //         }
    //     }
    //     let stack = [];
    //     stack.push(element);
    //     let result = [];
    //     let el : HTMLElement;
    //     while(stack.length>0){
    //         el = stack.shift();
    //         if(shallTraverseChildren(el)==false){
    //             stack.unshift(...el.children);
    //         }
    //         if(isFocusable(el)){
    //             result.push(el);
    //         }
    //     }
    //     return result;
    // }
    if (event.key === "Enter" && (<any>event).target.nodeName === 'INPUT') {
        event.preventDefault();
        event.stopImmediatePropagation();
        let form = findParent(<any>event.target) 
        let focusable = findFocusables(form);
        let index = focusable.index((<any>event).target)+1;
        if(index>=focusable.length){
            index = 0;
        }
        let next = focusable[index];
        next.focus();
    }
});

